import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const Word = ({ children, progress, range, hl }) => {
  const color = useTransform(progress, range, ["#b3ac9e", hl ? "#D4FF3D" : "#F1ECE2"]);
  const y = useTransform(progress, range, [6, 0]);
  return (
    <motion.span whileHover={{ y: -4, skewX: -8 }} transition={{ type: "spring", stiffness: 500, damping: 22 }}
      className="mr-[0.25em] inline-block cursor-default" style={{ y }}>
      <motion.span style={{ color }} className={`inline-block ${hl ? "underline decoration-[#FF4D1A]/60 decoration-2 underline-offset-[6px]" : ""}`}>{children}</motion.span>
    </motion.span>
  );
};

// Words brighten as you scroll; dim state already passes contrast.
export const ScrollWords = ({ text, highlight = [], className = "" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = text.split(" ");
  return (
    <p ref={ref} className={className} data-testid="manifesto-text">
      {words.map((w, i) => (
        <Word key={i} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]}
          hl={highlight.includes(w.replace(/[.,—]/g, ""))}>{w}</Word>
      ))}
    </p>
  );
};
